module.exports = __webpack_public_path__ + "img/info-item-3.791740e1.png";